// export default {
//   home: "الرئيسية",
//   restaurants: "المطاعم",
//   suppliers: "الموردين",
//   about: "معلومات عنا",
//   blog: "مدونة",
//   contact: "اتصل بنا",
//   login: "تسجيل الدخول",

//   login_as: "تسجيل الدخول كـ",
//   restaurant: "مطعم",
//   supplier: "مورد",
//   admin: "مدير",
//   orders_menu: "الطلبات والقائمة",
//   supply_mgmt: "إدارة التوريد",
//   system_control: "تحكم النظام",
// };


export default {
  home: "الرئيسية",
  restaurants: "المطاعم",
  suppliers: "الموردين",
  "about.menu": "معلومات عنا",
  blog: "المدونة",
  contact: "اتصل بنا",
  login: "تسجيل الدخول",

  login_as: "تسجيل الدخول كـ",
  restaurant: "مطعم",
  supplier: "مورد",
  admin: "مسؤول",

  orders_menu: "الطلبات والقائمة",
  supply_mgmt: "إدارة التوريد",
  system_control: "تحكم النظام",
};